import { __awaiter, __decorate } from "tslib";
import { Datasource, dataServerResultFilter, } from '@genesislcap/foundation-comms';
import { showNotificationToast } from '@genesislcap/foundation-notifications';
import { NotificationEvent, showNotification, } from '@genesislcap/foundation-notifications';
import { attr, nullableNumberConverter, observable } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { foundationNotificationListenerTemplate as template } from './notification-listener.template';
export const foundationNotificationListenerShadowOptions = {
    mode: 'open',
    delegatesFocus: true,
};
/**
 * @tagname %%prefix%%-notification-listener
 */
export class NotificationListener extends FoundationElement {
    constructor() {
        super(...arguments);
        /**
         * Number of milliseconds before toast will disappear. Leave empty or set to 0 to keep toast open indefinitely
         * @public
         */
        this.closeTimeout = 0;
        /**
         * Array of buttons for notification toasts
         * @public
         */
        this.toastButtons = [];
    }
    connectedCallback() {
        const _super = Object.create(null, {
            connectedCallback: { get: () => super.connectedCallback }
        });
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            _super.connectedCallback.call(this);
            this.addEventListener(NotificationEvent.NOTIFICATION_EVENT, (e) => {
                e.stopImmediatePropagation();
                showNotification(e.detail, this.tagName, this.notificationListener);
            });
            if (this.resourceName) {
                yield this.datasource.init({
                    resourceName: this.resourceName,
                }, true);
                (_a = this.datasource.stream) === null || _a === void 0 ? void 0 : _a.subscribe((result) => {
                    if (result.ROW && result.SEQUENCE_ID > 1) {
                        this.handleStreamUpdate(dataServerResultFilter(result));
                    }
                });
            }
        });
    }
    handleStreamUpdate(dataServerResult) {
        const rows = dataServerResult.inserts;
        if (rows.length > 0) {
            rows.forEach((row) => {
                var _a;
                const { HEADER: title, MESSAGE: message, NOTIFY_SEVERITY: type } = row;
                const createdAt = row.CREATED_AT ? new Date(row.CREATED_AT) : undefined;
                const expiry = row.EXPIRY ? row.EXPIRY - row.CREATED_AT : 0;
                let buttons = [];
                if (this.toastButtons && this.toastButtons.length > 0) {
                    buttons = this.toastButtons.filter(({ condition }) => !!condition ? condition({ details: row }) : true);
                }
                const toastStructure = {
                    title: title,
                    body: message,
                    createdAt: createdAt,
                    toast: {
                        details: row,
                        type: type === null || type === void 0 ? void 0 : type.toLowerCase(),
                        buttons: buttons,
                        autoClose: (_a = !!expiry) !== null && _a !== void 0 ? _a : !!this.closeTimeout,
                        closeTimeout: expiry !== null && expiry !== void 0 ? expiry : this.closeTimeout,
                    },
                };
                showNotificationToast(toastStructure, this.tagName);
            });
        }
    }
}
__decorate([
    observable
], NotificationListener.prototype, "notificationListener", void 0);
__decorate([
    attr({ attribute: 'resource-name' })
], NotificationListener.prototype, "resourceName", void 0);
__decorate([
    attr({ attribute: 'close-timeout', converter: nullableNumberConverter })
], NotificationListener.prototype, "closeTimeout", void 0);
__decorate([
    observable
], NotificationListener.prototype, "toastButtons", void 0);
__decorate([
    Datasource
], NotificationListener.prototype, "datasource", void 0);
/**
 * The Foundation Notification Listener
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-notification-listener\>
 */
export const foundationNotificationListener = NotificationListener.compose({
    baseName: 'notification-listener',
    template,
    shadowOptions: foundationNotificationListenerShadowOptions,
});
